// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[1]!../../../../node_modules/@fortawesome/fontawesome-pro/css/all.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].rules[0].oneOf[1].use[1]!../../../../node_modules/@angular/material/prebuilt-themes/deeppurple-amber.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screening-widget {
  padding: 10px;
  perspective: 6000px;
  height: 50vh;
  /* TABLE */
  /* WIDGET SETTINGS */
}
.screening-widget .dashboard-widget-screening {
  transition: transform 0.5s;
  transform-style: preserve-3d;
  box-shadow: 3px 2px 10px #89889c;
  height: 90%;
  margin: 20px;
}
.screening-widget .dashboard-widget-screening h1 {
  font-size: 20px;
  font-weight: 400;
  color: #43425d;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background: white;
  border: 0 !important;
}
.screening-widget .grid {
  grid-template-columns: repeat(6, auto);
  height: auto;
  overflow-y: scroll;
}
.screening-widget .grid i {
  padding-right: 10px;
  cursor: pointer;
}
.screening-widget .grid i.fa-thumbs-up,
.screening-widget .grid i.fa-search {
  padding-right: 5px;
}
.screening-widget .overlay {
  position: fixed;
  top: -30px;
  left: -30px;
  height: calc(100vh - 70px);
  width: calc(100vw - 220px);
  background: rgba(15, 26, 53, 0.3);
  z-index: 100;
}
.screening-widget .widget-face {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background: white;
}
.screening-widget .widget-face.front {
  display: flex;
  align-content: space-between;
  flex-flow: column nowrap;
}
.screening-widget .widget-face.back {
  background: white;
  transform: rotateX(180deg);
  overflow-y: hidden;
}
.screening-widget .is-flipped {
  transform: rotatex(180deg);
}
.screening-widget .widget-title {
  border-bottom: 2px solid #dedefd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
}
.screening-widget h1 i {
  color: #a29ffa;
  padding-right: 10px;
  font-size: 24px;
}
.screening-widget i.fa-cog {
  display: block;
  justify-content: right;
  cursor: pointer;
  padding: 0;
  font-size: 18px;
  color: #a29ffa;
}
.screening-widget h1 input[type="button"] {
  margin-left: 20px;
}
.screening-widget .footer {
  background: #0f1a35;
  width: 100%;
  padding: 5px;
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 0;
}
.screening-widget .footer input[type="button"] {
  box-shadow: 1px 2px 3px black;
}
.screening-widget .loader {
  padding-top: 5%;
  border-bottom: none;
  text-align: center;
}
.screening-widget .controls {
  position: relative;
  background: white;
  top: 200px;
  left: calc(50vw - 300px);
  border-radius: 5px;
  width: 300px;
  height: 150px;
  box-shadow: 1px 2px 3px black;
  text-align: center;
}
.screening-widget .controls h3 {
  font-size: 18px;
  color: white;
  background: #ce6161;
  border-bottom: 1px solid black;
  padding: 10px;
  border-radius: 5px 5px 0 0;
}
.screening-widget .controls p {
  padding: 10px;
  padding-top: 0;
  margin: 0;
}
.screening-widget .controls input[value="Continue"] {
  background: #54a54e;
  color: white;
}
.screening-widget .controls input[value="Cancel"] {
  background: #8e9bb5;
  color: white;
}
.screening-widget #propertyDecisions {
  height: 2.2em;
}
.screening-widget .notice {
  font-size: 12px;
}
.screening-widget ul {
  padding-top: 10px;
}
.screening-widget ul:before {
  font-size: 12px;
  content: "Select which columns you would like to display:";
}
.screening-widget li {
  font-size: 13px;
  line-height: 1.8;
  padding: 1px 0;
}
.screening-widget li:first-child {
  padding: 10px 0 10px 45px;
}
.screening-widget li span {
  display: inline-block;
  width: 20px;
  text-align: right;
  margin-right: 25px;
}
.screening-widget li i {
  font-size: 14px;
  color: black;
  padding-right: 10px;
}
.scrollable {
  max-height: 700px;
  height: auto;
  overflow-y: auto;
}
.scrollable th {
  text-align: left;
  z-index: 1;
  top: 0;
  position: sticky;
  background-color: white;
}
table {
  width: 99%;
}
table.center {
  text-align: center;
}
th {
  font-weight: 600;
  padding: 7px 5px;
  color: #4b58a6;
}
tr {
  border-bottom: 1px solid #e7ebeb;
  margin: 1%;
}
tr td {
  padding: 0.3%;
}
tr.invalid {
  background-color: #ce6161;
}
/* FONTS */
.cdk-global-overlay-wrapper,
.cdk-overlay-container {
  z-index: 1100 !important;
}
/* VARIABLES */
/* ELEMENTS */
body {
  font: 14px/1.2 "Source Sans Pro", sans-serif;
  background: #efeff7;
}
h1 {
  background: linear-gradient(to bottom, #dcdbed, #f2f1f9);
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  padding: 15px;
  border-bottom: 1px solid #d8d9ea;
  margin-bottom: 0;
}
h2 {
  background: white;
  margin: 0;
  padding: 15px;
  font-size: 18px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
h2 i {
  color: #a29ffa;
  padding-right: 5px;
}
h2.filter-title {
  background: whitesmoke;
  cursor: pointer;
}
h2.filter-title input:first-of-type {
  margin-left: 20px;
}
h4 {
  font-size: 14px;
  font-weight: 700;
}
a {
  color: #5484ff;
  text-decoration: none;
}
a:hover {
  color: #5484ff;
  text-decoration: none;
}
/* MODULES */
mat-slide-toggle {
  margin: auto;
}
app-clients-add .form-group,
app-screening .form-group {
  margin-bottom: 5px;
}
app-clients-add .form-group label,
app-screening .form-group {
  text-align: right;
}
/* FORM ELEMENTS */
form {
  background: white;
  padding-bottom: 20px;
  font-weight: 400;
}
input[type="text"],
input[type="password"],
input[type="number"],
input[type="date"],
select,
textarea {
  font-size: 1rem;
  font-weight: 400;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
}
input[type="text"][required],
input[type="password"][required],
input[type="number"][required],
input[type="date"][required],
select[required],
textarea[required] {
  border-left: 5px solid #ce6161;
}
input[type="text"].sorta-required,
input[type="password"].sorta-required,
input[type="number"].sorta-required,
input[type="date"].sorta-required,
select.sorta-required,
textarea.sorta-required {
  border-left: 5px solid #54a54e;
}
input[type="text"]::placeholder,
input[type="password"]::placeholder,
input[type="number"]::placeholder,
input[type="date"]::placeholder {
  color: #8e9bb5;
}
button,
input[type="button"] {
  background: #c1bffb;
  padding: 5px 25px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 50px;
  border: 0px;
  transition: 0.5s;
  box-shadow: 1px 2px 3px #89889c;
  margin: 5px;
  outline: none !important;
}
button.brblue,
input[type="button"].brblue {
  background: #5484ff;
  color: white;
}
button.mdgrey,
input[type="button"].mdgrey {
  background: #716f7a;
  color: white;
}
button:hover,
input[type="button"]:hover {
  background: #a29ffa;
}
button.small,
input[type=button].small {
  margin: 0 5px;
  padding: 2px 8px;
  font-size: 12px;
}
.form-control-xs {
  height: calc(0.8em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 0.8;
  border-radius: 0.2rem;
}
.input-group .fa-asterisk {
  padding: 3px;
  font-size: 8px;
  background: #dedefd;
  color: #43425d;
  border: 1px solid #ced4da;
  border-right: 0;
  border-radius: 0.25rem 0 0 0.25rem;
}
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append > .input-group-text {
  height: calc(1.5em + 0.5rem + 2px);
}
.mat-slide-toggle-content {
  font-weight: 700;
  color: #a29ffa;
}
.invalid-feedback {
  display: block;
  border: 1px solid #ce6161;
  border-radius: 3px;
  background: rgba(220, 0, 0, 0.1);
  margin-top: 0;
  margin-bottom: 0.6rem;
  color: #ce6161;
  font-size: 100%;
  padding: 5px;
  margin-left: 15px;
  margin-right: 15px;
}
.invalid-feedback:after {
  font-family: 'Font Awesome 5 Pro', sans-serif;
  font-weight: 900;
  float: right;
  content: "\\f0aa";
}
/* GRIDS */
.grid {
  display: grid;
  grid-auto-columns: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  padding: 0 10px;
  background: white;
  border-bottom: 1px solid #d8d9ea;
  padding-top: 20px;
}
.table-header {
  font-weight: 600;
  padding: 7px 5px;
  color: #4b58a6;
}
.table-data,
.table-blank {
  border-top: 1px solid #e7ebeb;
  padding: 7px 5px;
  align-content: center;
  align-items: center;
}
.table-data.link {
  color: #5484ff;
  cursor: pointer;
}
.table-blank {
  border-top: 0;
}
.grid i {
  font-size: 16px;
  display: inline-block;
}
.grid i.fa-link,
i.fa-unlink,
i.fa-edit,
i.fa-trash,
i.fa-sync,
i.fa-donate,
i.fa-window-close,
i.fa-envelope-open-text,
i.fa-folder-upload,
i.fa-share-square,
i.fa-contao,
i.fa-file-download,
i.fa-envelope,
i.fa-print,
i.fa-flag,
i.fa-sticky-note,
i.fa-file-check,
i.fa-exclamation,
i.fa-grimace,
i.fa-plus-square,
i.fa-arrow-alt-circle-down,
i.fa-exchange-alt,
i.fa-skull,
i.fa-bell,
i.fa-arrows,
i.fa-rotate,
i.fa-rotate-daveRocks,
i.fa-save,
i.fa-credit-card {
  color: #5484ff;
  cursor: pointer;
  margin: 1px;
  display: inline;
}
.grid .action-icons i {
  margin-right: 15px;
  color: #5484ff;
  cursor: pointer;
}
.grid .action-icons i.red {
  color: #ce6161;
}
.grid i.fas.fa-check {
  color: #54a54e;
}
.grid.info {
  padding: 20px 10px;
  width: 50%;
  float: left;
  grid-template-columns: repeat(2, auto);
}
.grid.info .table-header {
  text-align: right;
}
.grid.info .table-header:after {
  content: ':';
}
.grid.info .table-data,
.grid.notes-form .table-data {
  border-top: 0;
}
/* FILTERS */
.grid.filters {
  height: auto;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #d8d9ea;
  grid-row-gap: 12px;
}
.grid.filters input[type="text"],
.grid.filters input[type="password"],
.grid.filters input[type="number"],
.grid.filters input[type="date"],
.grid.filters textarea {
  border-width: 0;
  border-bottom-width: 1px;
  font-size: 1rem;
  font-weight: 400;
  height: 1.8rem;
  border-color: #8e9bb5;
  transition: 0.15s ease-in-out;
  outline: none;
  width: 95%;
  border-radius: 3px 3px 0 0;
  padding: 3px;
}
.grid.filters input[type="text"]:focus,
.grid.filters input[type="password"]:focus,
.grid.filters input[type="number"]:focus,
.grid.filters input[type="date"]:focus,
.grid.filters textarea:focus {
  border-color: #a29ffa;
  background: whitesmoke;
}
.grid.filters label {
  margin-bottom: 3px;
  font-weight: 400;
  font-size: 12px;
  padding-left: 3px;
  color: #716f7a;
  display: block;
}
.grid.filters .datepicker input {
  margin-bottom: 8px;
  text-align: center;
}
.grid.filters .datepicker select {
  margin-left: 5px;
}
.grid.filters .table-data {
  border: 0;
}
#results-pane,
.results-pane {
  background: whitesmoke;
  padding: 15px;
  border-top: 1px solid #d8d9ea;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#results-pane .records-page,
.results-pane .records-page {
  width: auto;
  float: right;
  font-size: 12px;
}
#results-pane select,
.results-pane select {
  display: inline;
  width: auto;
}
.paginate-button-panel {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paginate-button-panel i {
  color: #5484ff;
  font-size: 24px;
  padding: 0 10px;
  cursor: pointer;
}
.paginate-button-panel .current-page {
  font-size: 16px;
  line-height: 24px;
  padding: 0 8px;
  margin: 0 4px;
  border-radius: 20px;
  background: lightgrey;
  color: grey;
  width: 26px;
  height: 26px;
  text-align: center;
}
.highlight-this {
  background-color: yellow !important;
}
/* COLOR MARKERS */
.brblue {
  color: #5484ff;
}
.brpurple {
  color: #a29ffa;
}
.dkgrey {
  color: #43425d;
}
.grey {
  color: #8e9bb5;
}
.green {
  color: #54a54e;
}
.yellow {
  color: #e2b94f;
}
.orange {
  color: #d88949;
}
.red {
  color: #ce6161;
}
.teal {
  color: #379dac;
}
/* SIZE MARKERS */
.text-sm {
  font-size: 11px;
}
.text-lg {
  font-size: 16px;
}
.text-90 {
  font-size: 90%;
}
.text-80 {
  font-size: 80%;
}
/* WEIGHT MARKERS */
.bold {
  font-weight: 700;
}
/* ALIGNMENT MARKERS */
.left {
  text-align: left;
}
.center {
  text-align: center;
}
.right {
  text-align: right;
}
/* ResidentIQ */
.riq {
  display: inline-block;
  border-radius: 5px;
  background: #a4a3be;
  color: white;
  font-weight: 500;
  cursor: default;
  padding: 2px 5px;
}
.riq i {
  padding-right: 3px;
  font-size: 12px;
}
.riq.decline {
  background: #ce6161;
}
.riq.conditional-low {
  background: #d88949;
}
.riq.conditional-high {
  background: #e2b94f;
}
.riq.accept {
  background: #54a54e;
}
::ng-deep .tooltip-inner {
  background-color: #43425d;
}
::ng-deep .bs-tooltip-bottom .arrow:before {
  border-bottom-color: #43425d;
}
/* NOTES */
input[type="button"].note-changes,
button.note-changes {
  background: #3e73c9;
  color: white;
}
input[type="button"].note-setup,
button.note-setup {
  background: #379dac;
  color: white;
}
input[type="button"].note-checkin,
button.note-checkin {
  background: #6c6c6c;
  color: white;
}
input[type="button"].note-pastdue,
button.note-pastdue {
  background: #ce6161;
  color: white;
}
input[type="button"].note-payment,
button.note-payment {
  background: #54a54e;
  color: white;
}
input[type="button"].note-disabled,
button.note-disabled {
  background: #43425d;
  color: white;
}
input[type="button"].note-preguntas,
button.note-preguntas {
  background: #a29ffa;
  color: white;
}
input[type="button"].note-rerun,
button.note-rerun {
  background: #d88949;
  color: white;
}
input[type="button"].note-refund,
button.note-refund {
  background: #e2b94f;
  color: white;
}
input[type="button"].note-review,
button.note-review {
  background: #b1639f;
  color: white;
}
input[type="button"].note-label,
.note-label {
  color: white;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 400;
  margin: 3px;
  box-shadow: none;
}
input[type="button"].note-label.note-changes,
.note-label.note-changes {
  background: #3e73c9;
}
input[type="button"].note-label.note-setup,
.note-label.note-setup {
  background: #379dac;
}
input[type="button"].note-label.note-checkin,
.note-label.note-checkin {
  background: #6c6c6c;
}
input[type="button"].note-label.note-pastdue,
.note-label.note-pastdue {
  background: #ce6161;
}
input[type="button"].note-label.note-payment,
.note-label.note-payment {
  background: #54a54e;
}
input[type="button"].note-label.note-disabled,
.note-label.note-disabled {
  background: #43425d;
}
input[type="button"].note-label.note-preguntas,
.note-label.note-preguntas {
  background: #a29ffa;
}
input[type="button"].note-label.note-rerun,
.note-label.note-rerun {
  background: #d88949;
}
input[type="button"].note-label.note-refund,
.note-label.note-refund {
  background: #e2b94f;
}
input[type="button"].note-label.note-review,
.note-label.note-review {
  background: #b1639f;
}
i.note-changes {
  color: #3e73c9;
}
i.note-setup {
  color: #379dac;
}
i.note-checkin {
  color: #6c6c6c;
}
i.note-pastdue {
  color: #ce6161;
}
i.note-payment {
  color: #54a54e;
}
i.note-disabled {
  color: #43425d;
}
i.note-preguntas {
  color: #a29ffa;
}
i.note-rerun {
  color: #d88949;
}
i.note-refund {
  color: #e2b94f;
}
i.note-review {
  color: #b1639f;
}
/* MISCELLANEOUS */
.collapse-link {
  font-size: 12px;
  font-weight: 700;
  color: #5484ff;
}
/* PRINT STYLES */
@media print {
  body {
    background: white !important;
  }
  header {
    position: relative !important;
  }
  nav,
  .logo-holder img,
  .search-bar,
  .quick-nav {
    display: none;
  }
  main {
    left: 0 !important;
    width: 100% !important;
  }
  .logo-holder {
    background: url('ResIQ_Logo_Grey.359a4bddb741e95b.png') no-repeat center white !important;
    background-size: contain !important;
    margin-left: 10px;
  }
  .w-container {
    max-width: 100% !important;
  }
  .screening-report .header {
    border-width: 5px 0px !important;
    border-color: black !important;
    border-style: solid !important;
    background: none !important;
    color: black !important;
  }
  h4 {
    padding-left: 20px !important;
    border-bottom: 1px solid black !important;
    background: none !important;
    color: black !important;
  }
  h5 {
    background: #efefef !important;
  }
}
app-address-input {
  width: 100%;
}
@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
    color: rgba(127, 230, 118, 0.9);
    text-shadow: 0px 0px 20px #12a105;
  }
  100% {
    opacity: 1;
    color: black;
  }
}
.pulsing {
  animation: pulse 3s;
  animation-direction: alternate;
}
.residentIQ {
  animation: pulse 3s;
  animation-direction: alternate;
}
.form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  padding-left: 15px;
}
@keyframes sop-highlight-glow {
  0%,
  100% {
    box-shadow: 0 0 15px 12px rgba(29, 0, 249, 0.3);
  }
  50% {
    box-shadow: 0 0 36px 13px rgba(29, 0, 249, 0.8);
  }
}
@keyframes sop-highlight-fade-in {
  from {
    opacity: 0;
    outline-color: transparent;
    box-shadow: none;
  }
  to {
    opacity: 1;
  }
}
@keyframes sop-highlight-fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    outline-color: transparent;
    box-shadow: none;
  }
}
.sop-highlight {
  animation: sop-highlight-fade-in 0.4s ease-out, sop-highlight-glow 1s ease-in-out 0.4s infinite;
  outline: 2px solid rgba(124, 109, 240, 0.7);
  outline-offset: 2px;
  border-radius: 4px;
}
.sop-highlight-out {
  animation: sop-highlight-fade-out 0.5s ease-in forwards;
  outline: 2px solid rgba(124, 109, 240, 0.7);
  outline-offset: 2px;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/widgets/widgets.less","webpack://./src/app/shared-components-module/dynamic-table/dynamic-table.component.less","webpack://./src/assets/tables.less","webpack://./src/BootstrapMaterialOverride.less","webpack://./src/styles.less"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;ECAF,UAAU;EACV,oBAAoB;AACtB;ADLA;EAKQ,0BAAA;EACA,4BAAA;EACA,gCAAA;EAEA,WAAA;EACA,YAAA;ACER;ADZA;EAYY,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;ACGZ;ADvBA;EAyBQ,sCAAA;EACA,YAAA;EACA,kBAAA;ACCR;AD5BA;EA8BQ,mBAAA;EACA,eAAA;ACCR;ADhCA;;EAkCQ,kBAAA;ACER;ADpCA;EAqCQ,eAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;EACA,iCAAA;EACA,YAAA;ACER;AD7CA;EA8CQ,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;ACER;ADrDA;EAsDQ,aAAA;EACA,4BAAA;EACA,wBAAA;ACER;AD1DA;EA2DQ,iBAAA;EACA,0BAAA;EACA,kBAAA;ACER;AD/DA;EAgEQ,0BAAA;ACER;ADlEA;EAmEQ,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;ACER;ADzEA;EA2EQ,cAAA;EACA,mBAAA;EACA,eAAA;ACCR;AD9EA;EAgFQ,cAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;ACCR;ADtFA;EAwFQ,iBAAA;ACCR;ADzFA;EA2FQ,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;ACCR;ADlGA;EAoGQ,6BAAA;ACCR;ADrGA;EAyGQ,eAAA;EACA,mBAAA;EACA,kBAAA;ACDR;AD1GA;EA+GQ,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;ACFR;ADrHA;EA0HQ,eAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;ACFR;AD7HA;EAkIQ,aAAA;EACA,cAAA;EACA,SAAA;ACFR;ADlIA;EAuIQ,mBAAA;EACA,YAAA;ACFR;ADtIA;EA2IQ,mBAAA;EACA,YAAA;ACFR;AD1IA;EA+IQ,aAAA;ACFR;AD7IA;EAkJQ,eAAA;ACFR;ADhJA;EAyJQ,iBAAA;ACNR;ADnJA;EA4JQ,eAAA;EACA,0DAAA;ACNR;ADvJA;EAgKQ,eAAA;EACA,gBAAA;EACA,cAAA;ACNR;AD5JA;EAqKQ,yBAAA;ACNR;AD/JA;EAwKQ,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;ACNR;ADrKA;EA8KQ,eAAA;EACA,YAAA;EACA,mBAAA;ACNR;ACvKA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;ADyKJ;AC5KA;EAKQ,gBAAA;EACA,UAAA;EACA,MAAA;EACA,gBAAA;EACA,uBAAA;AD0KR;ACtKA;EACI,UAAA;ADwKJ;ACvKI;EACI,kBAAA;ADyKR;ACtKA;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;ADwKJ;ACtKA;EACI,gCAAA;EACA,UAAA;ADwKJ;AC1KA;EAIQ,aAAA;ADyKR;ACvKI;EACI,yBAAA;ADyKR;AACA,UAAU;AE7MV;;EACE,wBAAA;AFgNF;AACA,cAAc;AACd,aAAa;AGvKb;EACI,4CAAA;EACA,mBAAA;AHyKJ;AGvKA;EACI,wDAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,gBAAA;AHyKJ;AGvKA;EACI,iBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AHyKJ;AGvKA;EACI,cAAA;EACA,kBAAA;AHyKJ;AGvKA;EACI,sBAAA;EACA,eAAA;AHyKJ;AGvKA;EACI,iBAAA;AHyKJ;AGvKA;EACE,eAAA;EACA,gBAAA;AHyKF;AGvKA;EACI,cAAA;EACA,qBAAA;AHyKJ;AGvKA;EACI,cAAA;EACA,qBAAA;AHyKJ;AACA,YAAY;AGtKZ;EACE,YAAA;AHwKF;AGrKA;;EACE,kBAAA;AHwKF;AGtKA;;EACE,iBAAA;AHyKF;AACA,kBAAkB;AGtKlB;EACI,iBAAA;EACA,oBAAA;EACA,gBAAA;AHwKJ;AGtKA;;;;;;EACI,eAAA;EACA,gBAAA;EACA,wEAAA;EACA,aAAA;AH6KJ;AG5KI;;;;;;EACE,8BAAA;AHmLN;AGjLI;;;;;;EAEE,8BAAA;AHuLN;AGpLA;;;;EACI,cAAA;AHyLJ;AGvLA;;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,wBAAA;AH0LJ;AGxLA;;EACI,mBAAA;EACA,YAAA;AH2LJ;AGzLA;;EACI,mBAAA;EACA,YAAA;AH4LJ;AG1LA;;EACI,mBAAA;AH6LJ;AG3LA;;EACI,aAAA;EACA,gBAAA;EACA,eAAA;AH8LJ;AG5LA;EACE,kCAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AH8LF;AG5LA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,kCAAA;AH8LJ;AG5LA;;EACE,kCAAA;AH+LF;AG7LA;EACE,gBAAA;EACA,cAAA;AH+LF;AG7LA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AH+LF;AG7LA;EACE,6CAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AH+LF;AACA,UAAU;AG5LV;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;AH8LJ;AG5LA;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;AH8LJ;AG5LA;;EACI,6BAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AH+LJ;AG7LA;EACE,cAAA;EACA,eAAA;AH+LF;AG7LA;EACE,aAAA;AH+LF;AG7LA;EACI,eAAA;EACA,qBAAA;AH+LJ;AG7LA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6BI,cAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AH+LJ;AG7LA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AH+LF;AG7LA;EACE,cAAA;AH+LF;AG5LA;EACE,cAAA;AH8LF;AG5LA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;AH8LF;AG5LA;EAiKI,iBAAA;AH8BJ;AG5LA;EACE,YAAA;AH8LF;AG5LA;;EACE,aAAA;AH+LF;AACA,YAAY;AG3LZ;EACI,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AH6LJ;AGnMA;;;;;EAQM,eAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;AHkMN;AGpNA;;;;;EAqBM,qBAAA;EACA,sBAAA;AHsMN;AGnMA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AHqMJ;AGnMA;EACE,kBAAA;EACA,kBAAA;AHqMF;AGnMA;EACE,gBAAA;AHqMF;AGnMA;EACI,SAAA;AHqMJ;AGlMA;;EACI,sBAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AHqMJ;AGlMA;;EACI,WAAA;EACA,YAAA;EACA,eAAA;AHqMJ;AGlMA;;EACI,eAAA;EACA,WAAA;AHqMJ;AGlMA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AHoMJ;AGlMA;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AHoMJ;AGlMA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AHoMF;AGjMA;EACE,mCAAA;AHmMF;AACA,kBAAkB;AGhMlB;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AGhMA;EACI,cAAA;AHkMJ;AACA,iBAAiB;AG/LjB;EACI,eAAA;AHiMJ;AG/LA;EACI,eAAA;AHiMJ;AG/LA;EACE,cAAA;AHiMF;AG/LA;EACE,cAAA;AHiMF;AACA,mBAAmB;AG9LnB;EACI,gBAAA;AHgMJ;AACA,sBAAsB;AG7LtB;EACI,gBAAA;AH+LJ;AG7LA;EACI,kBAAA;AH+LJ;AG7LA;EACI,iBAAA;AH+LJ;AACA,eAAe;AG5Lf;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AH8LJ;AG5LA;EACI,kBAAA;EACA,eAAA;AH8LJ;AG5LA;EACI,mBAAA;AH8LJ;AG5LA;EACI,mBAAA;AH8LJ;AG5LA;EACI,mBAAA;AH8LJ;AG5LA;EACI,mBAAA;AH8LJ;AG5LA;EAEQ,yBAAA;AH6LR;AG/LA;EAKQ,4BAAA;AH6LR;AACA,UAAU;AGxLR;;EACE,mBAAA;EACA,YAAA;AH2LJ;AGzLE;;EACE,mBAAA;EACA,YAAA;AH4LJ;AG1LE;;EACE,mBAAA;EACA,YAAA;AH6LJ;AG3LE;;EACE,mBAAA;EACA,YAAA;AH8LJ;AG5LE;;EACE,mBAAA;EACA,YAAA;AH+LJ;AG7LE;;EACE,mBAAA;EACA,YAAA;AHgMJ;AG9LE;;EACE,mBAAA;EACA,YAAA;AHiMJ;AG/LE;;EACE,mBAAA;EACA,YAAA;AHkMJ;AGhME;;EACE,mBAAA;EACA,YAAA;AHmMJ;AGjME;;EACE,mBAAA;EACA,YAAA;AHoMJ;AGhMA;;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AHmMF;AGlME;;EACE,mBAAA;AHqMJ;AGnME;;EACE,mBAAA;AHsMJ;AGpME;;EACE,mBAAA;AHuMJ;AGrME;;EACE,mBAAA;AHwMJ;AGtME;;EACE,mBAAA;AHyMJ;AGvME;;EACE,mBAAA;AH0MJ;AGxME;;EACE,mBAAA;AH2MJ;AGzME;;EACE,mBAAA;AH4MJ;AG1ME;;EACE,mBAAA;AH6MJ;AG3ME;;EACE,mBAAA;AH8MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AGzME;EACE,cAAA;AH2MJ;AACA,kBAAkB;AGvMlB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AHyMJ;AACA,iBAAiB;AGtMjB;EACE;IACE,4BAAA;EHwMF;EGtMA;IACE,6BAAA;EHwMF;EGtMA;;;;IACE,aAAA;EH2MF;EGzMA;IACE,kBAAA;IACA,sBAAA;EH2MF;EGzMA;IACE,yFAAA;IACA,mCAAA;IACA,iBAAA;EH2MF;EGzMA;IACE,0BAAA;EH2MF;EGzMA;IACE,gCAAA;IACA,8BAAA;IACA,8BAAA;IACA,2BAAA;IACA,uBAAA;EH2MF;EGzMA;IACE,6BAAA;IACA,yCAAA;IACA,2BAAA;IACA,uBAAA;EH2MF;EGzMA;IACE,8BAAA;EH2MF;AACF;AGxMA;EACE,WAAA;AH0MF;AGpLA;EACE;IACI,YAAA;EHsLJ;EGpLA;IACI,UAAA;IACA,+BAAA;IACA,iCAAA;EHsLJ;EGpLA;IACI,UAAA;IACA,YAAA;EHsLJ;AACF;AGnLA;EACE,mBAAA;EACA,8BAAA;AHqLF;AGnLA;EAHE,mBAAA;EACA,8BAAA;AHyLF;AGnLA;EACE,iCAAA;EACA,oCAAA;EACA,kBAAA;AHqLF;AGjLA;EACE;;IAAW,+CAAA;EHqLX;EGpLA;IAAW,+CAAA;EHuLX;AACF;AGrLA;EACE;IAAO,UAAA;IAAY,0BAAA;IAA4B,gBAAA;EH0L/C;EGzLA;IAAO,UAAA;EH4LP;AACF;AG1LA;EACE;IAAO,UAAA;EH6LP;EG5LA;IAAO,UAAA;IAAY,0BAAA;IAA4B,gBAAA;EHiM/C;AACF;AG/LA;EACE,+FAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AHiMF;AG9LA;EACE,uDAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AHgMF","sourcesContent":["@import (reference) '../../styles.less';\n\n\n.screening-widget {\n    padding: 10px;\n    perspective: 6000px;\n    height: 50vh;\n    .dashboard-widget-screening {\n        transition: transform 0.5s;\n        transform-style: preserve-3d;\n        box-shadow: 3px 2px 10px @dropshadow;\n        // width: ~\"calc(90vw - 40px - @{sidebar-width})\";\n        height: 90%;\n        margin: 20px;\n        h1 {\n            font-size: 20px;\n            font-weight: 400;\n            color: @dkpurple;\n            padding: 0;\n            margin: 0;\n            display: flex;\n            align-items: center;\n            background: white;\n            border: 0 !important;\n        }\n    }\n    /* TABLE */\n    .grid {\n        grid-template-columns: repeat(6, auto);\n        height: auto;\n        overflow-y: scroll;\n    }\n    .grid i {\n        padding-right: 10px;\n        cursor: pointer;\n    }\n    .grid i.fa-thumbs-up, .grid i.fa-search {\n        padding-right: 5px;\n    }\n    .overlay {\n        position: fixed;\n        top: -30px;\n        left: -30px;\n        height: calc(100vh - @header-height);\n        width: calc(100vw - @sidebar-width);\n        background: @overlay;\n        z-index: 100;\n    }\n    .widget-face {\n        position: absolute;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        backface-visibility: hidden;\n        background: white;\n    }\n    .widget-face.front {\n        display: flex;\n        align-content: space-between;\n        flex-flow: column nowrap;\n    }\n    .widget-face.back {\n        background: white;\n        transform: rotateX(180deg);\n        overflow-y: hidden;\n    }\n    .is-flipped {\n        transform: rotatex(180deg);\n    }\n    .widget-title {\n        border-bottom: 2px solid @plpurple;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 10px 20px;\n    }\n    \n    h1 i {\n        color: @brpurple;\n        padding-right: 10px;\n        font-size: 24px;\n    }\n    i.fa-cog {\n        display: block;\n        justify-content: right;\n        cursor: pointer;\n        padding: 0;\n        font-size: 18px;\n        color: @brpurple;\n    }\n    h1 input[type=\"button\"] {\n        margin-left: 20px;\n    }\n    .footer {\n        background: @dkblue;\n        width: 100%;\n        padding: 5px;\n        text-align: center;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n    }\n    .footer input[type=\"button\"] {\n        box-shadow: @button-drop @darkshadow;\n    }\n    \n    \n    .loader {\n        padding-top: 5%;\n        border-bottom: none;\n        text-align: center;\n    }\n    \n    .controls {\n        position: relative;\n        background: white;\n        top: 200px;\n        left: calc(50vw - 300px);\n        border-radius: 5px;\n        width: 300px;\n        height: 150px;\n        box-shadow: 1px 2px 3px @darkshadow;\n        text-align: center;\n    }\n    .controls h3 {\n        font-size: 18px;\n        color: white;\n        background: @red;\n        border-bottom: 1px solid black;\n        padding: 10px;\n        border-radius: 5px 5px 0 0;\n    }\n    .controls p {\n        padding: 10px;\n        padding-top: 0;\n        margin: 0;\n    }\n    .controls input[value=\"Continue\"] {\n        background: @green;\n        color: white;\n    }\n    .controls input[value=\"Cancel\"] {\n        background: @grey;\n        color: white;\n    }\n    #propertyDecisions {\n        height: 2.2em;\n    }\n    .notice {\n        font-size: 12px;\n    }\n    \n    \n    /* WIDGET SETTINGS */\n    \n    ul {\n        padding-top: 10px;\n    }\n    ul:before {\n        font-size: 12px;\n        content: \"Select which columns you would like to display:\";\n    }\n    li {\n        font-size: 13px;\n        line-height: 1.8;\n        padding: 1px 0;\n    }\n    li:first-child {\n        padding: 10px 0 10px 45px;\n    }\n    li span {\n        display: inline-block;\n        width: 20px;\n        text-align: right;\n        margin-right: 25px;\n    }\n    li i {\n        font-size: 14px;\n        color: black;\n        padding-right: 10px;\n    }\n    \n    \n}\n","@import \"../../../~@fortawesome/fontawesome-pro/css/all.css\";\n@import \"../../../~@angular/material/prebuilt-themes/deeppurple-amber.css\";\n.screening-widget {\n  padding: 10px;\n  perspective: 6000px;\n  height: 50vh;\n  /* TABLE */\n  /* WIDGET SETTINGS */\n}\n.screening-widget .dashboard-widget-screening {\n  transition: transform 0.5s;\n  transform-style: preserve-3d;\n  box-shadow: 3px 2px 10px #89889c;\n  height: 90%;\n  margin: 20px;\n}\n.screening-widget .dashboard-widget-screening h1 {\n  font-size: 20px;\n  font-weight: 400;\n  color: #43425d;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 0 !important;\n}\n.screening-widget .grid {\n  grid-template-columns: repeat(6, auto);\n  height: auto;\n  overflow-y: scroll;\n}\n.screening-widget .grid i {\n  padding-right: 10px;\n  cursor: pointer;\n}\n.screening-widget .grid i.fa-thumbs-up,\n.screening-widget .grid i.fa-search {\n  padding-right: 5px;\n}\n.screening-widget .overlay {\n  position: fixed;\n  top: -30px;\n  left: -30px;\n  height: calc(100vh - 70px);\n  width: calc(100vw - 220px);\n  background: rgba(15, 26, 53, 0.3);\n  z-index: 100;\n}\n.screening-widget .widget-face {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  backface-visibility: hidden;\n  background: white;\n}\n.screening-widget .widget-face.front {\n  display: flex;\n  align-content: space-between;\n  flex-flow: column nowrap;\n}\n.screening-widget .widget-face.back {\n  background: white;\n  transform: rotateX(180deg);\n  overflow-y: hidden;\n}\n.screening-widget .is-flipped {\n  transform: rotatex(180deg);\n}\n.screening-widget .widget-title {\n  border-bottom: 2px solid #dedefd;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n}\n.screening-widget h1 i {\n  color: #a29ffa;\n  padding-right: 10px;\n  font-size: 24px;\n}\n.screening-widget i.fa-cog {\n  display: block;\n  justify-content: right;\n  cursor: pointer;\n  padding: 0;\n  font-size: 18px;\n  color: #a29ffa;\n}\n.screening-widget h1 input[type=\"button\"] {\n  margin-left: 20px;\n}\n.screening-widget .footer {\n  background: #0f1a35;\n  width: 100%;\n  padding: 5px;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n.screening-widget .footer input[type=\"button\"] {\n  box-shadow: 1px 2px 3px black;\n}\n.screening-widget .loader {\n  padding-top: 5%;\n  border-bottom: none;\n  text-align: center;\n}\n.screening-widget .controls {\n  position: relative;\n  background: white;\n  top: 200px;\n  left: calc(50vw - 300px);\n  border-radius: 5px;\n  width: 300px;\n  height: 150px;\n  box-shadow: 1px 2px 3px black;\n  text-align: center;\n}\n.screening-widget .controls h3 {\n  font-size: 18px;\n  color: white;\n  background: #ce6161;\n  border-bottom: 1px solid black;\n  padding: 10px;\n  border-radius: 5px 5px 0 0;\n}\n.screening-widget .controls p {\n  padding: 10px;\n  padding-top: 0;\n  margin: 0;\n}\n.screening-widget .controls input[value=\"Continue\"] {\n  background: #54a54e;\n  color: white;\n}\n.screening-widget .controls input[value=\"Cancel\"] {\n  background: #8e9bb5;\n  color: white;\n}\n.screening-widget #propertyDecisions {\n  height: 2.2em;\n}\n.screening-widget .notice {\n  font-size: 12px;\n}\n.screening-widget ul {\n  padding-top: 10px;\n}\n.screening-widget ul:before {\n  font-size: 12px;\n  content: \"Select which columns you would like to display:\";\n}\n.screening-widget li {\n  font-size: 13px;\n  line-height: 1.8;\n  padding: 1px 0;\n}\n.screening-widget li:first-child {\n  padding: 10px 0 10px 45px;\n}\n.screening-widget li span {\n  display: inline-block;\n  width: 20px;\n  text-align: right;\n  margin-right: 25px;\n}\n.screening-widget li i {\n  font-size: 14px;\n  color: black;\n  padding-right: 10px;\n}\n.scrollable {\n  max-height: 700px;\n  height: auto;\n  overflow-y: auto;\n}\n.scrollable th {\n  text-align: left;\n  z-index: 1;\n  top: 0;\n  position: sticky;\n  background-color: white;\n}\ntable {\n  width: 99%;\n}\ntable.center {\n  text-align: center;\n}\nth {\n  font-weight: 600;\n  padding: 7px 5px;\n  color: #4b58a6;\n}\ntr {\n  border-bottom: 1px solid #e7ebeb;\n  margin: 1%;\n}\ntr td {\n  padding: 0.3%;\n}\ntr.invalid {\n  background-color: #ce6161;\n}\n/* FONTS */\n.cdk-global-overlay-wrapper,\n.cdk-overlay-container {\n  z-index: 1100 !important;\n}\n/* VARIABLES */\n/* ELEMENTS */\nbody {\n  font: 14px/1.2 \"Source Sans Pro\", sans-serif;\n  background: #efeff7;\n}\nh1 {\n  background: linear-gradient(to bottom, #dcdbed, #f2f1f9);\n  font-size: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  padding: 15px;\n  border-bottom: 1px solid #d8d9ea;\n  margin-bottom: 0;\n}\nh2 {\n  background: white;\n  margin: 0;\n  padding: 15px;\n  font-size: 18px;\n  font-weight: 400;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\nh2 i {\n  color: #a29ffa;\n  padding-right: 5px;\n}\nh2.filter-title {\n  background: whitesmoke;\n  cursor: pointer;\n}\nh2.filter-title input:first-of-type {\n  margin-left: 20px;\n}\nh4 {\n  font-size: 14px;\n  font-weight: 700;\n}\na {\n  color: #5484ff;\n  text-decoration: none;\n}\na:hover {\n  color: #5484ff;\n  text-decoration: none;\n}\n/* MODULES */\nmat-slide-toggle {\n  margin: auto;\n}\napp-clients-add .form-group,\napp-screening .form-group {\n  margin-bottom: 5px;\n}\napp-clients-add .form-group label,\napp-screening .form-group {\n  text-align: right;\n}\n/* FORM ELEMENTS */\nform {\n  background: white;\n  padding-bottom: 20px;\n  font-weight: 400;\n}\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\nselect,\ntextarea {\n  font-size: 1rem;\n  font-weight: 400;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  outline: none;\n}\ninput[type=\"text\"][required],\ninput[type=\"password\"][required],\ninput[type=\"number\"][required],\ninput[type=\"date\"][required],\nselect[required],\ntextarea[required] {\n  border-left: 5px solid #ce6161;\n}\ninput[type=\"text\"].sorta-required,\ninput[type=\"password\"].sorta-required,\ninput[type=\"number\"].sorta-required,\ninput[type=\"date\"].sorta-required,\nselect.sorta-required,\ntextarea.sorta-required {\n  border-left: 5px solid #54a54e;\n}\ninput[type=\"text\"]::placeholder,\ninput[type=\"password\"]::placeholder,\ninput[type=\"number\"]::placeholder,\ninput[type=\"date\"]::placeholder {\n  color: #8e9bb5;\n}\nbutton,\ninput[type=\"button\"] {\n  background: #c1bffb;\n  padding: 5px 25px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 50px;\n  border: 0px;\n  transition: 0.5s;\n  box-shadow: 1px 2px 3px #89889c;\n  margin: 5px;\n  outline: none !important;\n}\nbutton.brblue,\ninput[type=\"button\"].brblue {\n  background: #5484ff;\n  color: white;\n}\nbutton.mdgrey,\ninput[type=\"button\"].mdgrey {\n  background: #716f7a;\n  color: white;\n}\nbutton:hover,\ninput[type=\"button\"]:hover {\n  background: #a29ffa;\n}\nbutton.small,\ninput[type=button].small {\n  margin: 0 5px;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n.form-control-xs {\n  height: calc(0.8em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 0.8;\n  border-radius: 0.2rem;\n}\n.input-group .fa-asterisk {\n  padding: 3px;\n  font-size: 8px;\n  background: #dedefd;\n  color: #43425d;\n  border: 1px solid #ced4da;\n  border-right: 0;\n  border-radius: 0.25rem 0 0 0.25rem;\n}\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append > .input-group-text {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n.mat-slide-toggle-content {\n  font-weight: 700;\n  color: #a29ffa;\n}\n.invalid-feedback {\n  display: block;\n  border: 1px solid #ce6161;\n  border-radius: 3px;\n  background: rgba(220, 0, 0, 0.1);\n  margin-top: 0;\n  margin-bottom: 0.6rem;\n  color: #ce6161;\n  font-size: 100%;\n  padding: 5px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.invalid-feedback:after {\n  font-family: 'Font Awesome 5 Pro', sans-serif;\n  font-weight: 900;\n  float: right;\n  content: \"\\f0aa\";\n}\n/* GRIDS */\n.grid {\n  display: grid;\n  grid-auto-columns: auto;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.2;\n  padding: 0 10px;\n  background: white;\n  border-bottom: 1px solid #d8d9ea;\n  padding-top: 20px;\n}\n.table-header {\n  font-weight: 600;\n  padding: 7px 5px;\n  color: #4b58a6;\n}\n.table-data,\n.table-blank {\n  border-top: 1px solid #e7ebeb;\n  padding: 7px 5px;\n  align-content: center;\n  align-items: center;\n}\n.table-data.link {\n  color: #5484ff;\n  cursor: pointer;\n}\n.table-blank {\n  border-top: 0;\n}\n.grid i {\n  font-size: 16px;\n  display: inline-block;\n}\n.grid i.fa-link,\ni.fa-unlink,\ni.fa-edit,\ni.fa-trash,\ni.fa-sync,\ni.fa-donate,\ni.fa-window-close,\ni.fa-envelope-open-text,\ni.fa-folder-upload,\ni.fa-share-square,\ni.fa-contao,\ni.fa-file-download,\ni.fa-envelope,\ni.fa-print,\ni.fa-flag,\ni.fa-sticky-note,\ni.fa-file-check,\ni.fa-exclamation,\ni.fa-grimace,\ni.fa-plus-square,\ni.fa-arrow-alt-circle-down,\ni.fa-exchange-alt,\ni.fa-skull,\ni.fa-bell,\ni.fa-arrows,\ni.fa-rotate,\ni.fa-rotate-daveRocks,\ni.fa-save,\ni.fa-credit-card {\n  color: #5484ff;\n  cursor: pointer;\n  margin: 1px;\n  display: inline;\n}\n.grid .action-icons i {\n  margin-right: 15px;\n  color: #5484ff;\n  cursor: pointer;\n}\n.grid .action-icons i.red {\n  color: #ce6161;\n}\n.grid i.fas.fa-check {\n  color: #54a54e;\n}\n.grid.info {\n  padding: 20px 10px;\n  width: 50%;\n  float: left;\n  grid-template-columns: repeat(2, auto);\n}\n.grid.info .table-header {\n  text-align: right;\n}\n.grid.info .table-header:after {\n  content: ':';\n}\n.grid.info .table-data,\n.grid.notes-form .table-data {\n  border-top: 0;\n}\n/* FILTERS */\n.grid.filters {\n  height: auto;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #d8d9ea;\n  grid-row-gap: 12px;\n}\n.grid.filters input[type=\"text\"],\n.grid.filters input[type=\"password\"],\n.grid.filters input[type=\"number\"],\n.grid.filters input[type=\"date\"],\n.grid.filters textarea {\n  border-width: 0;\n  border-bottom-width: 1px;\n  font-size: 1rem;\n  font-weight: 400;\n  height: 1.8rem;\n  border-color: #8e9bb5;\n  transition: 0.15s ease-in-out;\n  outline: none;\n  width: 95%;\n  border-radius: 3px 3px 0 0;\n  padding: 3px;\n}\n.grid.filters input[type=\"text\"]:focus,\n.grid.filters input[type=\"password\"]:focus,\n.grid.filters input[type=\"number\"]:focus,\n.grid.filters input[type=\"date\"]:focus,\n.grid.filters textarea:focus {\n  border-color: #a29ffa;\n  background: whitesmoke;\n}\n.grid.filters label {\n  margin-bottom: 3px;\n  font-weight: 400;\n  font-size: 12px;\n  padding-left: 3px;\n  color: #716f7a;\n  display: block;\n}\n.grid.filters .datepicker input {\n  margin-bottom: 8px;\n  text-align: center;\n}\n.grid.filters .datepicker select {\n  margin-left: 5px;\n}\n.grid.filters .table-data {\n  border: 0;\n}\n#results-pane,\n.results-pane {\n  background: whitesmoke;\n  padding: 15px;\n  border-top: 1px solid #d8d9ea;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n#results-pane .records-page,\n.results-pane .records-page {\n  width: auto;\n  float: right;\n  font-size: 12px;\n}\n#results-pane select,\n.results-pane select {\n  display: inline;\n  width: auto;\n}\n.paginate-button-panel {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.paginate-button-panel i {\n  color: #5484ff;\n  font-size: 24px;\n  padding: 0 10px;\n  cursor: pointer;\n}\n.paginate-button-panel .current-page {\n  font-size: 16px;\n  line-height: 24px;\n  padding: 0 8px;\n  margin: 0 4px;\n  border-radius: 20px;\n  background: lightgrey;\n  color: grey;\n  width: 26px;\n  height: 26px;\n  text-align: center;\n}\n.highlight-this {\n  background-color: yellow !important;\n}\n/* COLOR MARKERS */\n.brblue {\n  color: #5484ff;\n}\n.brpurple {\n  color: #a29ffa;\n}\n.dkgrey {\n  color: #43425d;\n}\n.grey {\n  color: #8e9bb5;\n}\n.green {\n  color: #54a54e;\n}\n.yellow {\n  color: #e2b94f;\n}\n.orange {\n  color: #d88949;\n}\n.red {\n  color: #ce6161;\n}\n.teal {\n  color: #379dac;\n}\n/* SIZE MARKERS */\n.text-sm {\n  font-size: 11px;\n}\n.text-lg {\n  font-size: 16px;\n}\n.text-90 {\n  font-size: 90%;\n}\n.text-80 {\n  font-size: 80%;\n}\n/* WEIGHT MARKERS */\n.bold {\n  font-weight: 700;\n}\n/* ALIGNMENT MARKERS */\n.left {\n  text-align: left;\n}\n.center {\n  text-align: center;\n}\n.right {\n  text-align: right;\n}\n/* ResidentIQ */\n.riq {\n  display: inline-block;\n  border-radius: 5px;\n  background: #a4a3be;\n  color: white;\n  font-weight: 500;\n  cursor: default;\n  padding: 2px 5px;\n}\n.riq i {\n  padding-right: 3px;\n  font-size: 12px;\n}\n.riq.decline {\n  background: #ce6161;\n}\n.riq.conditional-low {\n  background: #d88949;\n}\n.riq.conditional-high {\n  background: #e2b94f;\n}\n.riq.accept {\n  background: #54a54e;\n}\n::ng-deep .tooltip-inner {\n  background-color: #43425d;\n}\n::ng-deep .bs-tooltip-bottom .arrow:before {\n  border-bottom-color: #43425d;\n}\n/* NOTES */\ninput[type=\"button\"].note-changes,\nbutton.note-changes {\n  background: #3e73c9;\n  color: white;\n}\ninput[type=\"button\"].note-setup,\nbutton.note-setup {\n  background: #379dac;\n  color: white;\n}\ninput[type=\"button\"].note-checkin,\nbutton.note-checkin {\n  background: #6c6c6c;\n  color: white;\n}\ninput[type=\"button\"].note-pastdue,\nbutton.note-pastdue {\n  background: #ce6161;\n  color: white;\n}\ninput[type=\"button\"].note-payment,\nbutton.note-payment {\n  background: #54a54e;\n  color: white;\n}\ninput[type=\"button\"].note-disabled,\nbutton.note-disabled {\n  background: #43425d;\n  color: white;\n}\ninput[type=\"button\"].note-preguntas,\nbutton.note-preguntas {\n  background: #a29ffa;\n  color: white;\n}\ninput[type=\"button\"].note-rerun,\nbutton.note-rerun {\n  background: #d88949;\n  color: white;\n}\ninput[type=\"button\"].note-refund,\nbutton.note-refund {\n  background: #e2b94f;\n  color: white;\n}\ninput[type=\"button\"].note-review,\nbutton.note-review {\n  background: #b1639f;\n  color: white;\n}\ninput[type=\"button\"].note-label,\n.note-label {\n  color: white;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 400;\n  margin: 3px;\n  box-shadow: none;\n}\ninput[type=\"button\"].note-label.note-changes,\n.note-label.note-changes {\n  background: #3e73c9;\n}\ninput[type=\"button\"].note-label.note-setup,\n.note-label.note-setup {\n  background: #379dac;\n}\ninput[type=\"button\"].note-label.note-checkin,\n.note-label.note-checkin {\n  background: #6c6c6c;\n}\ninput[type=\"button\"].note-label.note-pastdue,\n.note-label.note-pastdue {\n  background: #ce6161;\n}\ninput[type=\"button\"].note-label.note-payment,\n.note-label.note-payment {\n  background: #54a54e;\n}\ninput[type=\"button\"].note-label.note-disabled,\n.note-label.note-disabled {\n  background: #43425d;\n}\ninput[type=\"button\"].note-label.note-preguntas,\n.note-label.note-preguntas {\n  background: #a29ffa;\n}\ninput[type=\"button\"].note-label.note-rerun,\n.note-label.note-rerun {\n  background: #d88949;\n}\ninput[type=\"button\"].note-label.note-refund,\n.note-label.note-refund {\n  background: #e2b94f;\n}\ninput[type=\"button\"].note-label.note-review,\n.note-label.note-review {\n  background: #b1639f;\n}\ni.note-changes {\n  color: #3e73c9;\n}\ni.note-setup {\n  color: #379dac;\n}\ni.note-checkin {\n  color: #6c6c6c;\n}\ni.note-pastdue {\n  color: #ce6161;\n}\ni.note-payment {\n  color: #54a54e;\n}\ni.note-disabled {\n  color: #43425d;\n}\ni.note-preguntas {\n  color: #a29ffa;\n}\ni.note-rerun {\n  color: #d88949;\n}\ni.note-refund {\n  color: #e2b94f;\n}\ni.note-review {\n  color: #b1639f;\n}\n/* MISCELLANEOUS */\n.collapse-link {\n  font-size: 12px;\n  font-weight: 700;\n  color: #5484ff;\n}\n/* PRINT STYLES */\n@media print {\n  body {\n    background: white !important;\n  }\n  header {\n    position: relative !important;\n  }\n  nav,\n  .logo-holder img,\n  .search-bar,\n  .quick-nav {\n    display: none;\n  }\n  main {\n    left: 0 !important;\n    width: 100% !important;\n  }\n  .logo-holder {\n    background: url('../../../assets/images/ResIQ_Logo_Grey.png') no-repeat center white !important;\n    background-size: contain !important;\n    margin-left: 10px;\n  }\n  .w-container {\n    max-width: 100% !important;\n  }\n  .screening-report .header {\n    border-width: 5px 0px !important;\n    border-color: black !important;\n    border-style: solid !important;\n    background: none !important;\n    color: black !important;\n  }\n  h4 {\n    padding-left: 20px !important;\n    border-bottom: 1px solid black !important;\n    background: none !important;\n    color: black !important;\n  }\n  h5 {\n    background: #efefef !important;\n  }\n}\napp-address-input {\n  width: 100%;\n}\n@keyframes pulse {\n  0% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n    color: rgba(127, 230, 118, 0.9);\n    text-shadow: 0px 0px 20px #12a105;\n  }\n  100% {\n    opacity: 1;\n    color: black;\n  }\n}\n.pulsing {\n  animation: pulse 3s;\n  animation-direction: alternate;\n}\n.residentIQ {\n  animation: pulse 3s;\n  animation-direction: alternate;\n}\n.form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  padding-left: 15px;\n}\n@keyframes sop-highlight-glow {\n  0%,\n  100% {\n    box-shadow: 0 0 15px 12px rgba(29, 0, 249, 0.3);\n  }\n  50% {\n    box-shadow: 0 0 36px 13px rgba(29, 0, 249, 0.8);\n  }\n}\n@keyframes sop-highlight-fade-in {\n  from {\n    opacity: 0;\n    outline-color: transparent;\n    box-shadow: none;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes sop-highlight-fade-out {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    outline-color: transparent;\n    box-shadow: none;\n  }\n}\n.sop-highlight {\n  animation: sop-highlight-fade-in 0.4s ease-out, sop-highlight-glow 1s ease-in-out 0.4s infinite;\n  outline: 2px solid rgba(124, 109, 240, 0.7);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n.sop-highlight-out {\n  animation: sop-highlight-fade-out 0.5s ease-in forwards;\n  outline: 2px solid rgba(124, 109, 240, 0.7);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n","@import '../styles.less';\n\n@rd:#ec6f6f;\n@yw:#fae9af;\n@bl:#afcefa;\n@brd:#a0c2f1;\n.scrollable{\n    max-height:700px;\n    height: auto;\n    overflow-y: auto;\n    th {\n        text-align: left;\n        z-index: 1;\n        top: 0;\n        position: sticky;\n        background-color: white;\n      }\n}\n\ntable{\n    width: 99%;\n    &.center{\n        text-align: center;\n    }     \n}\nth{\n    font-weight: 600;\n    padding: 7px 5px;\n    color: #4b58a6;    \n}\ntr{\n    border-bottom: 1px solid #e7ebeb;\n    margin: 1%;\n    td{\n        padding:.3%;\n    };\n    &.invalid{\n        background-color: @red;\n    }\n}","\n// This will override the material select dropdown being rendered behind the bootstrap modal overlay\n.cdk-global-overlay-wrapper, .cdk-overlay-container {\n  z-index: 1100 !important;\n}\n","/* FONTS */\n@import (css) \"~@fortawesome/fontawesome-pro/css/all.css\";\n@import (css) \"~@angular/material/prebuilt-themes/deeppurple-amber.css\";\n\n// Import the bootstrap angular material overridesz\n@import \"BootstrapMaterialOverride\";\n\n/* VARIABLES */\n@sdpurple: #3c3c54;\n@dkpurple: #43425d;\n@mdpurple: #4b58a6;\n@brpurple: #a29ffa;\n@plpurple: #dedefd;\n@ltpurple: #efeff7;\n@dkblue: #0f1a35;\n@mdblue: #1e305e;\n@brblue: #5484ff;\n@skyblue: #4297d5;\n@dkgrey: #43425d;\n@mdgrey: #716f7a;\n@grey: #8e9bb5;\n@ltgrey: #a4a3be;\n@yellow: #e2b94f;\n@green: #54a54e;\n@orange: #d88949;\n@red: #ce6161;\n@teal: #379dac;\n@dkteal: #36577b;\n\n@dropshadow: #89889c;\n@darkshadow: black;\n@overlay: rgba(15,26,53,0.3);\n@header-height: 70px;\n@sidebar-width: 220px;\n@sidebar-color: @dkblue;\n@logo-holder: @dkblue;\n@profile-link: @dkblue;\n@profile-hover: @mdblue;\n@grid-row: rgba(whitesmoke, 0.3);\n@button: #c1bffb;\n@button-drop: 1px 2px 3px;\n@grid: #e7ebeb;\n@h1-gradient: linear-gradient(to bottom, #dcdbed, #f2f1f9);\n@h1-bottom: #d8d9ea;\n\n/* ELEMENTS */\nbody {\n    font: 14px/1.2 \"Source Sans Pro\", sans-serif;\n    background: @ltpurple;\n}\nh1 {\n    background: @h1-gradient;\n    font-size: 20px;\n    line-height: 20px;\n    font-weight: 600;\n    padding: 15px;\n    border-bottom: 1px solid @h1-bottom;\n    margin-bottom: 0;\n}\nh2 {\n    background: white;\n    margin: 0;\n    padding: 15px;\n    font-size: 18px;\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\nh2 i {\n    color: @brpurple;\n    padding-right: 5px;\n}\nh2.filter-title {\n    background: whitesmoke;\n    cursor: pointer;\n}\nh2.filter-title input:first-of-type {\n    margin-left: 20px;\n}\nh4 {\n  font-size: 14px;\n  font-weight: 700;\n}\na {\n    color: @brblue;\n    text-decoration: none;\n}\na:hover {\n    color: @brblue;\n    text-decoration: none;\n}\n\n/* MODULES */\nmat-slide-toggle {\n  margin: auto;\n}\n\napp-clients-add .form-group, app-screening .form-group {\n  margin-bottom: 5px;\n}\napp-clients-add .form-group label, app-screening .form-group {\n  text-align: right;\n}\n\n/* FORM ELEMENTS */\nform {\n    background: white;\n    padding-bottom: 20px;\n    font-weight: 400;\n}\ninput[type=\"text\"], input[type=\"password\"], input[type=\"number\"], input[type=\"date\"], select, textarea {\n    font-size: 1rem;\n    font-weight: 400;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    outline: none;\n    &[required] {\n      border-left: 5px solid @red;\n    }\n    &.sorta-required\n    {\n      border-left: 5px solid @green;\n    }\n}\ninput[type=\"text\"]::placeholder, input[type=\"password\"]::placeholder, input[type=\"number\"]::placeholder, input[type=\"date\"]::placeholder {\n    color: @grey;\n}\nbutton, input[type=\"button\"] {\n    background: @button;\n    padding: 5px 25px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 50px;\n    border: 0px;\n    transition: 0.5s;\n    box-shadow: @button-drop @dropshadow;\n    margin: 5px;\n    outline: none !important;\n}\nbutton.brblue, input[type=\"button\"].brblue {\n    background: @brblue;\n    color: white;\n}\nbutton.mdgrey, input[type=\"button\"].mdgrey {\n    background: @mdgrey;\n    color: white;\n}\nbutton:hover, input[type=\"button\"]:hover {\n    background: @brpurple;\n}\nbutton.small, input[type=button].small {\n    margin: 0 5px;\n    padding: 2px 8px;\n    font-size: 12px;\n}\n.form-control-xs {\n  height: calc(.8em + .5rem + 2px);\n  padding: .25rem .5rem;\n  font-size: .875rem;\n  line-height: .8;\n  border-radius: .2rem;\n}\n.input-group .fa-asterisk {\n    padding: 3px;\n    font-size: 8px;\n    background: @plpurple;\n    color: @dkpurple;\n    border: 1px solid #ced4da;\n    border-right: 0;\n    border-radius: 0.25rem 0 0 0.25rem;\n}\n.input-group>.input-group-prepend>.input-group-text, .input-group>.input-group-append>.input-group-text {\n  height: calc(1.5em + .5rem + 2px);\n}\n.mat-slide-toggle-content {\n  font-weight: 700;\n  color: @brpurple;\n}\n.invalid-feedback {\n  display: block;\n  border: 1px solid @red;\n  border-radius: 3px;\n  background: rgba(220, 0, 0, 0.1);\n  margin-top: 0;\n  margin-bottom: .6rem;\n  color: @red;\n  font-size: 100%;\n  padding: 5px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.invalid-feedback:after {\n  font-family: 'Font Awesome 5 Pro', sans-serif;\n  font-weight: 900;\n  float: right;\n  content: \"\\f0aa\";\n}\n\n/* GRIDS */\n.grid {\n    display: grid;\n    grid-auto-columns: auto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    padding: 0 10px;\n    background: white;\n    border-bottom: 1px solid @h1-bottom;\n    padding-top: 20px;\n}\n.table-header {\n    font-weight: 600;\n    padding: 7px 5px;\n    color: @mdpurple;\n}\n.table-data, .table-blank {\n    border-top: 1px solid @grid;\n    padding: 7px 5px;\n    align-content: center;\n    align-items: center;\n}\n.table-data.link {\n  color: @brblue;\n  cursor: pointer;\n}\n.table-blank {\n  border-top: 0;\n}\n.grid i {\n    font-size: 16px;\n    display: inline-block;\n}\n.grid i.fa-link,\ni.fa-unlink,\ni.fa-edit,\ni.fa-trash,\ni.fa-sync,\ni.fa-donate,\ni.fa-window-close,\ni.fa-envelope-open-text,\ni.fa-folder-upload,\ni.fa-share-square,\ni.fa-contao,\ni.fa-file-download,\ni.fa-envelope,\ni.fa-print,\ni.fa-flag,\ni.fa-sticky-note,\ni.fa-file-check,\ni.fa-exclamation,\ni.fa-grimace,\ni.fa-plus-square,\ni.fa-arrow-alt-circle-down,\ni.fa-exchange-alt,\ni.fa-skull,\ni.fa-bell,\ni.fa-arrows,\ni.fa-rotate,\ni.fa-rotate-daveRocks,\ni.fa-save,\ni.fa-credit-card {\n    color: @brblue;\n    cursor: pointer;\n    margin: 1px;\n    display: inline;\n}\n.grid .action-icons i {\n  margin-right: 15px;\n  color: @brblue;\n  cursor: pointer;\n}\n.grid .action-icons i.red {\n  color: @red;\n}\n\n.grid i.fas.fa-check {\n  color: @green;\n}\n.grid.info {\n  padding: 20px 10px;\n  width: 50%;\n  float: left;\n  grid-template-columns: repeat(2, auto);\n}\n.grid.info .table-header {\n  .right;\n}\n.grid.info .table-header:after {\n  content: ':';\n}\n.grid.info .table-data, .grid.notes-form .table-data {\n  border-top: 0;\n}\n\n\n/* FILTERS */\n.grid.filters {\n    height: auto;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid @h1-bottom;\n    grid-row-gap: 12px;\n    input[type=\"text\"], input[type=\"password\"], input[type=\"number\"], input[type=\"date\"],textarea {\n      border-width: 0;\n      border-bottom-width: 1px;\n      font-size: 1rem;\n      font-weight: 400;\n      height: 1.8rem;\n      border-color: @grey;\n      transition: 0.15s ease-in-out;\n      outline: none;\n      width: 95%;\n      border-radius: 3px 3px 0 0;\n      padding: 3px;\n    }\n    input[type=\"text\"]:focus, input[type=\"password\"]:focus, input[type=\"number\"]:focus, input[type=\"date\"]:focus, textarea:focus {\n      border-color: @brpurple;\n      background: whitesmoke;\n    }\n}\n.grid.filters label {\n    margin-bottom: 3px;\n    font-weight: 400;\n    font-size: 12px;\n    padding-left: 3px;\n    color: @mdgrey;\n    display: block;\n}\n.grid.filters .datepicker input {\n  margin-bottom: 8px;\n  text-align: center;\n}\n.grid.filters .datepicker select {\n  margin-left: 5px;\n}\n.grid.filters .table-data {\n    border: 0;\n}\n\n#results-pane, .results-pane {\n    background: whitesmoke;\n    padding: 15px;\n    border-top: 1px solid @h1-bottom;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n#results-pane .records-page, .results-pane .records-page{\n    width: auto;\n    float: right;\n    font-size: 12px;\n}\n\n#results-pane select, .results-pane select {\n    display: inline;\n    width: auto;\n}\n\n.paginate-button-panel {\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.paginate-button-panel i {\n    color: @brblue;\n    font-size: 24px;\n    padding: 0 10px;\n    cursor: pointer;\n}\n.paginate-button-panel .current-page {\n  font-size: 16px;\n  line-height: 24px;\n  padding: 0 8px;\n  margin: 0 4px;\n  border-radius: 20px;\n  background: lightgrey;\n  color: grey;\n  width: 26px;\n  height: 26px;\n  text-align: center;\n}\n\n.highlight-this {\n  background-color: yellow !important;\n}\n\n/* COLOR MARKERS */\n.brblue {\n    color: @brblue;\n}\n.brpurple {\n    color: @brpurple;\n}\n.dkgrey {\n    color: @dkgrey;\n}\n.grey {\n    color: @grey;\n}\n.green {\n    color: @green;\n}\n.yellow {\n    color: @yellow;\n}\n.orange {\n    color: @orange;\n}\n.red {\n    color: @red;\n}\n.teal {\n    color: @teal;\n}\n\n/* SIZE MARKERS */\n.text-sm {\n    font-size: 11px;\n}\n.text-lg {\n    font-size: 16px;\n}\n.text-90 {\n  font-size: 90%;\n}\n.text-80 {\n  font-size: 80%;\n}\n\n/* WEIGHT MARKERS */\n.bold {\n    font-weight: 700;\n}\n\n/* ALIGNMENT MARKERS */\n.left {\n    text-align: left;\n}\n.center {\n    text-align: center;\n}\n.right {\n    text-align: right;\n}\n\n/* ResidentIQ */\n.riq {\n    display: inline-block;\n    border-radius: 5px;\n    background: @ltgrey;\n    color: white;\n    font-weight: 500;\n    cursor: default;\n    padding: 2px 5px;\n}\n.riq i {\n    padding-right: 3px;\n    font-size: 12px;\n}\n.riq.decline {\n    background: @red;\n}\n.riq.conditional-low {\n    background: @orange;\n}\n.riq.conditional-high {\n    background: @yellow;\n}\n.riq.accept {\n    background: @green;\n}\n::ng-deep {\n    .tooltip-inner {\n        background-color: @dkgrey;\n    }\n    .bs-tooltip-bottom .arrow:before {\n        border-bottom-color: @dkgrey;\n    }\n}\n\n/* NOTES */\ninput[type=\"button\"], button {\n  &.note-changes {\n    background: #3e73c9;\n    color: white;\n  }\n  &.note-setup {\n    background: #379dac;\n    color: white;\n  }\n  &.note-checkin {\n    background: #6c6c6c;\n    color: white;\n  }\n  &.note-pastdue {\n    background: @red;\n    color: white;\n  }\n  &.note-payment {\n    background: @green;\n    color: white;\n  }\n  &.note-disabled {\n    background: @dkgrey;\n    color: white;\n  }\n  &.note-preguntas {\n    background: @brpurple;\n    color: white;\n  }\n  &.note-rerun {\n    background: @orange;\n    color: white;\n  }\n  &.note-refund {\n    background: @yellow;\n    color: white;\n  }\n  &.note-review {\n    background: #b1639f;\n    color: white;\n  }\n}\n\ninput[type=\"button\"].note-label, .note-label {\n  color: white;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 400;\n  margin: 3px;\n  box-shadow: none;\n  &.note-changes {\n    background: #3e73c9;\n  }\n  &.note-setup {\n    background: #379dac;\n  }\n  &.note-checkin {\n    background: #6c6c6c;\n  }\n  &.note-pastdue {\n    background: @red;\n  }\n  &.note-payment {\n    background: @green;\n  }\n  &.note-disabled {\n    background: @dkgrey;\n  }\n  &.note-preguntas {\n    background: @brpurple;\n  }\n  &.note-rerun {\n    background: @orange;\n  }\n  &.note-refund {\n    background: @yellow;\n  }\n  &.note-review {\n    background: #b1639f;\n  }\n}\n\ni {\n  &.note-changes {\n    color: #3e73c9;\n  }\n  &.note-setup {\n    color: #379dac;\n  }\n  &.note-checkin {\n    color: #6c6c6c;\n  }\n  &.note-pastdue {\n    color: @red;\n  }\n  &.note-payment {\n    color: @green;\n  }\n  &.note-disabled {\n    color: @dkgrey;\n  }\n  &.note-preguntas {\n    color: @brpurple;\n  }\n  &.note-rerun {\n    color: @orange;\n  }\n  &.note-refund {\n    color: @yellow;\n  }\n  &.note-review {\n    color: #b1639f;\n  }\n}\n\n/* MISCELLANEOUS */\n.collapse-link {\n    font-size: 12px;\n    font-weight: 700;\n    color: @brblue;\n}\n\n/* PRINT STYLES */\n@media print {\n  body {\n    background: white !important;\n  }\n  header {\n    position: relative !important;\n  }\n  nav, .logo-holder img, .search-bar, .quick-nav {\n    display: none;\n  }\n  main {\n    left: 0 !important;\n    width: 100% !important;\n  }\n  .logo-holder {\n    background: url('assets/images/ResIQ_Logo_Grey.png') no-repeat center white !important;\n    background-size: contain !important;\n    margin-left: 10px;\n  }\n  .w-container {\n    max-width: 100% !important;\n  }\n  .screening-report .header {\n    border-width: 5px 0px !important;\n    border-color: black !important;\n    border-style: solid !important;\n    background: none !important;\n    color: black !important;\n  }\n  h4 {\n    padding-left: 20px !important;\n    border-bottom: 1px solid black !important;\n    background: none !important;\n    color: black !important;\n  }\n  h5 {\n    background: #efefef !important;\n  }\n}\n\napp-address-input{\n  width:100%;\n}\n\n\n// @keyframes pulse {\n//   0% {\n//       opacity: 1;\n//       // color: black\n//   }\n//   50% {\n//       opacity: 1;\n//       // background-color: rgba(18,161,5,0.2);\n//       color : rgb(127, 230, 118);\n//       text-shadow: 0px 0px 15px rgba(18,161,5);\n//   }\n//   100% {\n//       opacity: 1;\n//       color: black;\n//   }\n// }\n\n\n@keyframes pulse {\n  0% {\n      opacity: 0.5;\n  }\n  50% {\n      opacity: 1;\n      color : rgba(127, 230, 118,0.9);\n      text-shadow: 0px 0px 20px rgba(18,161,5,1);\n  }\n  100% {\n      opacity: 1;\n      color: black;\n  }\n}\n\n.pulsing {\n  animation: pulse 3s;\n  animation-direction: alternate;\n}\n.residentIQ{\n  .pulsing;\n}\n\n.form-label {\n  padding-top: calc(.375rem + 1px);\n  padding-bottom: calc(.375rem + 1px);\n  padding-left: 15px;\n}\n\n// SOP assistant highlight glow\n@keyframes sop-highlight-glow {\n  0%, 100% { box-shadow: 0 0 15px 12px  rgba(29,0,249,0.3); }\n  50%      { box-shadow: 0 0 36px 13px rgba(29,0,249,0.8); }\n}\n\n@keyframes sop-highlight-fade-in {\n  from { opacity: 0; outline-color: transparent; box-shadow: none; }\n  to   { opacity: 1; }\n}\n\n@keyframes sop-highlight-fade-out {\n  from { opacity: 1; }\n  to   { opacity: 0; outline-color: transparent; box-shadow: none; }\n}\n\n.sop-highlight {\n  animation: sop-highlight-fade-in 0.4s ease-out, sop-highlight-glow 1s ease-in-out 0.4s infinite;\n  outline: 2px solid rgba(124, 109, 240, 0.7);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.sop-highlight-out {\n  animation: sop-highlight-fade-out 0.5s ease-in forwards;\n  outline: 2px solid rgba(124, 109, 240, 0.7);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n// @keyframes sop-highlight-glow {\n//   0%, 100% { box-shadow: 0 0 15px 12px  rgba(29,0,249,0.3); }\n//   50%      { box-shadow: 0 0 36px 13px rgba(29,0,249,0.8); }\n// }\n\n// .sop-highlight {\n//   animation: sop-highlight-glow 1.5s ease-in-out infinite;\n//   outline: 1px solid rgba(0,51,255,0.2);\n//   outline-offset: 3px;\n//   border-radius: 12px;\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
